import MenuDataAnalytics from "../MenuDataAnalytics";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function JornadaCliente() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/data-analytics">Data Analytics</a>
                  </li>
                  <li className="breadcrumb-item active">Jornada do Cliente</li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuDataAnalytics />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">Jornada do Cliente</h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Data Analytics</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Conheça seu cliente
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  A jornada do cliente é o caminho percorrido pelo consumidor
                  desde o primeiro contato com a marca até a concretização da
                  compra e além.
                </p>

                <p>
                  Uma jornada bem mapeada e otimizada melhora a experiência do
                  cliente, aumenta a satisfação, e pode levar à recomendação da
                  marca para outros potenciais consumidores, fechando um ciclo
                  contínuo de atração e retenção.
                </p>

                <p>
                  Pensando nisso, disponibilizamos ações personalizadas por
                  segmento, com base em cada etapa da jornada do seu cliente,
                  para te auxiliar na tomada de decisãos estratégicas.
                </p>

                <figure>
                  <a
                    href={`/imagepage?image=${encodeURIComponent(
                      "img/jornada-do-cliente.gif"
                    )}`}
                    target="_blank"
                  >
                    <img
                      src="img/jornada-do-cliente.gif"
                      alt="excel"
                      style={{ display: "block", margin: "0 auto" }}
                    />
                  </a>
                </figure>

                <figcaption>Jornada do cliente: Ações</figcaption>

                <p>
                  Aqui estão alguns benefícios importantes de compreender essa
                  jornada:
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Melhoria da Experiência do Cliente:
                    </a>{" "}
                    Ao mapear a jornada do cliente, as empresas podem
                    identificar pontos de atrito e oportunidades para melhorar a
                    experiência do usuário em cada etapa. Isso pode levar a um
                    aumento na satisfação do cliente, maior lealdade à marca.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Personalização Efetiva:
                    </a>{" "}
                    Com um entendimento claro da jornada do cliente, personalize
                    suas comunicações e ofertas para atender às necessidades e
                    preferências específicas dos clientes em diferentes
                    estágios. Isso não apenas melhora a relevância das
                    interações, mas também aumenta as taxas de conversão.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Aumento das Vendas e Cross-Selling:
                    </a>{" "}
                    Ao conhecer a jornada do cliente, as empresas podem
                    identificar os momentos ideais para introduzir ofertas
                    adicionais ou upgrades, aumentando assim as oportunidades de
                    venda cruzada e de upselling de uma maneira que se sinta
                    natural e oportuna para o cliente.
                  </li>
                </ul>

                <p>
                  Ao focar na jornada do cliente, os clientes da{" "}
                  <a href="https://salesbox.com.br/" target="blank">
                    SalesBox
                  </a>{" "}
                  não só elevam a qualidade da experiência oferecida, como
                  também impulsionam o crescimento sustentável ao construir
                  relações mais fortes e duradouras com seus clientes.
                </p>

                <p>
                  Para acessar essas informações na{" "}
                  <a href="https://salesbox.com.br/identity/" target="blank">
                    Plataforma
                  </a>
                  , clique em <a style={{ fontWeight: "bold" }}>Analisar</a>, em
                  seguida em{" "}
                  <a style={{ fontWeight: "bold" }}>Gestão de bases</a>,
                  identifique a base que deseja analisar e clique em{" "}
                  <a style={{ fontWeight: "bold" }}>Análise de segmentação</a>.
                </p>

                <figure>
                  <a
                    href={`/imagepage?image=${encodeURIComponent(
                      "img/gestao-de-bases.png"
                    )}`}
                    target="_blank"
                  >
                    <img
                      src="img/gestao-de-bases.png"
                      alt="excel"
                      style={{ display: "block", margin: "0 auto" }}
                    />
                  </a>
                </figure>

                <figcaption>Gestão de bases: Analisar</figcaption>

                <figure>
                  <a
                    href={`/imagepage?image=${encodeURIComponent(
                      "img/analise-de-segmentacao.png"
                    )}`}
                    target="_blank"
                  >
                    <img
                      src="img/analise-de-segmentacao.png"
                      alt="excel"
                      style={{ display: "block", margin: "0 auto" }}
                    />
                  </a>
                </figure>

                <figcaption>Análise de Segmentação: Gestão de bases</figcaption>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
